import { useEffect, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { VendorContext } from '../../context/VendorProvider';
import { WebsiteContext } from '../../context/WebsiteProvider';

const ModalHandler = ({ type }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    getVendor,
    setSelectedVendor,
    openModal: openVendorModal,
  } = useContext(VendorContext);

  const {
    getWebsite,
    setSelectedWebsite,
    openModal: openWebsiteModal,
  } = useContext(WebsiteContext);

  useEffect(() => {
    if (type === 'vendor' && id) {
      getVendor(id)
        .then((vendor) => {
          if (vendor) {
            setSelectedVendor(vendor);
            openVendorModal();
          } else {
            navigate('/not-found', { replace: true });
          }
        })
        .catch(() => navigate('/not-found', { replace: true }));
    }

    if (type === 'website' && id) {
      getWebsite(id)
        .then((website) => {
          if (website) {
            setSelectedWebsite(website);
            openWebsiteModal();
          } else {
            navigate('/not-found', { replace: true });
          }
        })
        .catch(() => navigate('/not-found', { replace: true }));
    }
  }, [ type, navigate, ]);

  return null;
};

export default ModalHandler;
